import { sharedStyles } from "./MotInvitation.shared.styles";

export const styles = {
  ...sharedStyles,
  errorIconWrapper: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    backgroundColor: "#FFF0F0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "24px",
  },
  errorIconImg: {
    width: "40px",
    height: "40px",
  },
  infoCard: {
    backgroundColor: "#FFF5F5",
    borderRadius: "12px",
    width: "100%",
    overflow: "hidden",
    marginBottom: "32px",
  },
  infoCardBody: {
    padding: "20px",
    color: "#1A2B3C",
    fontSize: "16px",
    lineHeight: "1.6",
    textAlign: "center",
    margin: "0",
  },
  closeButton: {
    ...sharedStyles.actionButton,
    backgroundColor: "#1B3A2D",
    color: "#4CAF50",
  },
};
